import { render, staticRenderFns } from "./PartnerJobsView.vue?vue&type=template&id=64dd5bec"
import script from "./PartnerJobsView.vue?vue&type=script&lang=js"
export * from "./PartnerJobsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports